import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../../config/firebase';

export async function uploadFile(file: File, userId: string): Promise<{ downloadUrl: string, storagePath: string }> {
  try {
    // Create a unique file path
    const timestamp = Date.now();
    const storagePath = `documents/${userId}/${timestamp}_${file.name}`;
    const storageRef = ref(storage, storagePath);

    // Upload the file
    await uploadBytes(storageRef, file);

    // Get the download URL
    const downloadUrl = await getDownloadURL(storageRef);

    return { downloadUrl, storagePath };
  } catch (error: any) {
    console.error('Error uploading file:', error);
    console.error('Detailed error:', error); // Adicionado log detalhado do erro
    throw new Error('Falha ao fazer upload do arquivo');
  }
}
